import { Route } from "lucide-react";
import {
  ProcessTraceParamsSchema,
  defaultProcessTraceParams,
  WIDGET_LABELS,
  type ProcessTraceParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { ProcessTraceWidget } from "./Component.js";
import { ProcessTraceExpandedEditor } from "./ExpandedEditor.js";

export const processTraceDef: SqlWidgetDef<ProcessTraceParams> = {
  kind: "processTrace",
  label: WIDGET_LABELS.processTrace,
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 752, h: 384 },
  defaultParams: defaultProcessTraceParams,
  Component: ProcessTraceWidget,
  ExpandedComponent: ProcessTraceExpandedEditor,
  expandable: true,
  storage: "sql",
  schema: ProcessTraceParamsSchema,
  accent: "purple",
  icon: Route,
  subtitle: "Recognition → occurrence → cause",
  defaultRoster: true,
  category: "multi",
  layout: { col: "full", row: 3, width: 752, height: 360 },
  renderSubtitle: (data) =>
    data.subject.trim() || "Recognition → occurrence → cause",
  renderFooter: (data) => {
    const evidenceCount = [
      data.por.evidence,
      data.poo.evidence,
      data.poc.evidence,
    ].filter((evidence) => evidence.trim() !== "").length;
    const establishedCount = [
      data.por.observation.trim() || data.por.location.trim(),
      data.poo.divergence.trim() || data.poo.location.trim(),
      data.poc.cause.trim() || data.poc.location.trim(),
    ].filter(Boolean).length;
    return {
      left: `${establishedCount}/3 trace points`,
      right: `${evidenceCount} evidence link${evidenceCount === 1 ? "" : "s"}`,
    };
  },
  askAiPrompt:
    "Help me build a Causal Chain Analysis from Point of Recognition to Point of Occurrence and Point of Cause. Keep unsupported points blank and do not treat POC as validated without direct evidence or a discriminating test.",
};

registerWidget(processTraceDef);
